const PersonIcon = ({ width, height }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? 16}
            height={height ?? width ?? 16}
            viewBox="0 0 48 48"
        >
            <g fill="none">
                <path
                    fill="url(#IconifyId195c956c13d57d05c0)"
                    d="M12.25 28A4.25 4.25 0 0 0 8 32.249V33c0 3.756 1.942 6.567 4.92 8.38C15.85 43.163 19.786 44 24 44s8.15-.837 11.08-2.62C38.058 39.567 40 36.756 40 33v-.751A4.25 4.25 0 0 0 35.75 28z"
                />
                <path
                    fill="url(#IconifyId195c956c13d57d05c1)"
                    d="M12.25 28A4.25 4.25 0 0 0 8 32.249V33c0 3.756 1.942 6.567 4.92 8.38C15.85 43.163 19.786 44 24 44s8.15-.837 11.08-2.62C38.058 39.567 40 36.756 40 33v-.751A4.25 4.25 0 0 0 35.75 28z"
                />
                <path
                    fill="url(#IconifyId195c956c13d57d05c2)"
                    d="M24 4c-5.523 0-10 4.477-10 10s4.477 10 10 10s10-4.477 10-10S29.523 4 24 4"
                />
                <defs>
                    <linearGradient
                        id="IconifyId195c956c13d57d05c0"
                        x1="15.61"
                        x2="20.779"
                        y1="30.127"
                        y2="46.635"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".125" stopColor="#9C6CFE" />
                        <stop offset="1" stopColor="#7A41DC" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId195c956c13d57d05c1"
                        x1="24"
                        x2="31.238"
                        y1="26.095"
                        y2="53.143"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#885EDB" stopOpacity="0" />
                        <stop offset="1" stopColor="#E362F8" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId195c956c13d57d05c2"
                        x1="18.756"
                        x2="28.949"
                        y1="6.659"
                        y2="22.934"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".125" stopColor="#9C6CFE" />
                        <stop offset="1" stopColor="#7A41DC" />
                    </linearGradient>
                </defs>
            </g>
        </svg>
    );
};

export default PersonIcon;
